module.exports = __webpack_public_path__ + "img/reset-white.114887c6.svg";